import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gestionclient',
  templateUrl: './gestionclient.component.html',
  styleUrls: ['./gestionclient.component.scss']
})
export class GestionclientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
